var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"rounded-0",staticStyle:{"font-size":"0.6em"},attrs:{"items":_vm.options,"append-icon":"mdi-chevron-double-down","dense":"","solo":"","background-color":"transparent","hide-details":""},model:{value:(_vm.option),callback:function ($$v) {_vm.option=$$v},expression:"option"}})
}
var staticRenderFns = []

export { render, staticRenderFns }